import React from 'react';
import {
  Form,
  Input,
  Radio,
  Typography,
  InputNumber,
  Row,
  Col,
  Modal,
  Alert,
} from 'antd';
import CustomSelector from '../../components/CustomSelector';
import { getSupportTypes } from '../../api/module/term_products';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Paragraph } = Typography;

const HasLimitField = ({ onlyUnlimited, onChange, ...restProps }) => {
  const onSelfChange = (e) => {
    if (!e.target.value) {
      Modal.confirm({
        title: 'Aviso',
        icon: <ExclamationCircleOutlined />,
        content: (
          <>
            Esta opción SOLO aplica para proyectos <b>tipo ICFES</b>. ¿Desea
            continuar?
          </>
        ),
        okText: 'Si',
        cancelText: 'No',
        onOk: () => onChange(e),
      });
    } else {
      onChange(e);
    }
  };
  return (
    <Radio.Group
      style={{ marginLeft: '2rem' }}
      onChange={onSelfChange}
      {...restProps}
    >
      <Radio value={true} disabled={onlyUnlimited}>
        Si
      </Radio>
      <Radio value={false}>No</Radio>
    </Radio.Group>
  );
};

const ProductFields = ({
  onlyUnlimited,
  currencyType,
  alwaysDetailed = false,
}) => {
  return (
    <>
      <Form.Item
        name="es_apoyo"
        rules={[
          {
            required: true,
            message: 'Tiene que escoger una opción',
          },
        ]}
      >
        <Radio.Group style={{ marginLeft: '2rem' }}>
          <Radio value={false}>Producto y/o entregable</Radio>
          <Radio value={true}>Gastos u otros ítems</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item noStyle dependencies={['es_apoyo']}>
        {({ getFieldValue }) => {
          const ea = getFieldValue('es_apoyo');
          if (ea == undefined) return null;
          const labelType = ea ? 'gasto/ítem' : 'producto';
          return (
            <>
              {ea ? (
                <>
                  <Paragraph>
                    Verifique que los gastos u otros ítems variables sean
                    consistentes con los ítems del presupuesto del proyecto y/o
                    entidad
                  </Paragraph>
                  <Form.Item
                    label="Seleccione el gasto"
                    name="tipo_apoyo"
                    rules={[
                      {
                        required: true,
                        message: 'Este campo es obligatorio!',
                      },
                    ]}
                    valuePropName="initialValue"
                  >
                    <CustomSelector endpointFetch={getSupportTypes} />
                  </Form.Item>
                  <Form.Item noStyle dependencies={['tipo_apoyo']}>
                    {({ getFieldValue }) =>
                      getFieldValue('tipo_apoyo') === 100 ? (
                        <Form.Item
                          label={`Digite el concepto del ${labelType}`}
                          name="descripcion"
                          rules={[
                            {
                              required: true,
                              message: 'Este campo es obligatorio!',
                            },
                          ]}
                          tooltip={{
                            placement: 'top',
                            title: `No use las palabras "Apoyo" o "Auxilio" en el concepto del ${labelType}.`,
                          }}
                        >
                          <TextArea rows={4} bordered allowClear />
                        </Form.Item>
                      ) : null
                    }
                  </Form.Item>
                </>
              ) : (
                <Form.Item
                  name="descripcion"
                  label="Producto y/o entregable"
                  rules={[
                    {
                      required: true,
                      message: 'Este campo es obligatorio!',
                    },
                  ]}
                >
                  <TextArea rows={4} bordered allowClear />
                </Form.Item>
              )}
              {!alwaysDetailed && (
                <Form.Item
                  name="info_detallada"
                  label={`¿Conoce la información detallada del ${labelType}?`}
                  rules={[
                    {
                      required: true,
                      message: 'Tiene que escoger una opción',
                    },
                  ]}
                  tooltip={{
                    placement: 'top',
                    title: `La información detallada incluye: Si el ${labelType} requiere evidencias, si tiene pago fijo o variable, etc.`,
                  }}
                >
                  <Radio.Group style={{ marginLeft: '2rem' }}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              )}
              <Form.Item noStyle dependencies={['info_detallada']}>
                {({ getFieldValue }) =>
                  getFieldValue('info_detallada') || alwaysDetailed ? (
                    <>
                      <Form.Item
                        name="requiere_evidencias"
                        label="¿El contratista debe cargar soportes/evidencias en SIGA para la aprobación de este producto/gasto?"
                        rules={[
                          {
                            required: true,
                            message: 'Tiene que escoger una opción',
                          },
                        ]}
                      >
                        <Radio.Group style={{ marginLeft: '2rem' }}>
                          <Radio value={true}>Si</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Form.Item>
                      <Form.Item
                        name="variable"
                        label={`¿Este ${labelType} tiene pago fijo o variable?`}
                        rules={[
                          {
                            required: true,
                            message: 'Tiene que escoger una opción',
                          },
                        ]}
                        tooltip={{
                          placement: 'top',
                          title: `Valor unitario según ${labelType} (horas, talleres, tutorías, etc)`,
                        }}
                      >
                        <Radio.Group style={{ marginLeft: '2rem' }}>
                          <Radio value={false} disabled={onlyUnlimited}>
                            Fijo
                          </Radio>
                          <Radio value={true}>Variable</Radio>
                        </Radio.Group>
                      </Form.Item>
                      <Form.Item noStyle dependencies={['variable']}>
                        {({ getFieldValue }) => {
                          const v = getFieldValue('variable');
                          if (v)
                            return (
                              <>
                                <Form.Item
                                  name="tiene_tope"
                                  label={`¿Este ${labelType} tiene topes?`}
                                  tooltip={{
                                    placement: 'top',
                                    title: `Si el ${labelType} tiene un máximo a pagar y un máximo de unidades`,
                                  }}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Tiene que escoger una opción',
                                    },
                                  ]}
                                >
                                  <HasLimitField
                                    onlyUnlimited={onlyUnlimited}
                                  />
                                </Form.Item>
                                <Form.Item
                                  noStyle
                                  dependencies={['tiene_tope']}
                                >
                                  {({ getFieldValue }) =>
                                    getFieldValue('tiene_tope') ? (
                                      <Form.Item
                                        name="maximo_unitario"
                                        label={`Tope de unidades máximas a pagar de este ${labelType}`}
                                        rules={[
                                          {
                                            required: true,
                                            message:
                                              'Este campo es obligatorio!',
                                          },
                                          {
                                            validator: (_, value) => {
                                              if (!value) {
                                                return Promise.resolve();
                                              } else if (isNaN(value)) {
                                                return Promise.reject(
                                                  new Error(
                                                    'Debe ser un valor numérico',
                                                  ),
                                                );
                                              }
                                              if (value < 0) {
                                                return Promise.reject(
                                                  new Error(
                                                    'Debe ser positivo',
                                                  ),
                                                );
                                              }
                                              if (value < 1.01) {
                                                return Promise.reject(
                                                  new Error(
                                                    'Debe ser mayor a 1 o en caso contrario seleccione pago fijo',
                                                  ),
                                                );
                                              }
                                              if (
                                                value
                                                  .toString()
                                                  .includes('.') &&
                                                value
                                                  .toString()
                                                  .split('.', 2)[1].length > 2
                                              ) {
                                                return Promise.reject(
                                                  new Error(
                                                    'Debe ser un valor con máximo dos decimales',
                                                  ),
                                                );
                                              }

                                              return Promise.resolve();
                                            },
                                          },
                                        ]}
                                      >
                                        <InputNumber
                                          style={{ width: '100%' }}
                                          formatter={(value) =>
                                            `${value}`.replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ',',
                                            )
                                          }
                                          parser={(value) =>
                                            value.replace(/\$\s?|(,*)/g, '')
                                          }
                                        />
                                      </Form.Item>
                                    ) : null
                                  }
                                </Form.Item>
                                <Form.Item
                                  name="nombre_unitario"
                                  label={`Nombre de la unidad de este ${labelType}`}
                                  tooltip={{
                                    placement: 'top',
                                    title:
                                      'Digite en singular si es hora, taller, tutoría, etc.',
                                  }}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Este campo es obligatorio!',
                                    },
                                    {
                                      type: 'string',
                                      max: 50,
                                      message:
                                        'El nombre de la unidad no debe de superar los 50 caracteres',
                                    },
                                    {
                                      type: 'string',
                                      pattern: /^[a-záéíóúñü (){}[\]_%+"-]+$/,
                                      message: 'Utilice unicamente minúsculas',
                                    },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                                <Form.Item
                                  name="valor_unitario"
                                  label={`Valor de la unidad de este ${labelType}`}
                                  tooltip={{
                                    placement: 'top',
                                    title: `Valor unitario según ${labelType} (horas, talleres, tutorías, etc)`,
                                  }}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Este campo es obligatorio!',
                                    },
                                    {
                                      validator: (_, value) => {
                                        if (!value) {
                                          return Promise.resolve();
                                        } else if (isNaN(value)) {
                                          return Promise.reject(
                                            new Error(
                                              'Debe ser un valor numérico',
                                            ),
                                          );
                                        }
                                        if (value < 0) {
                                          return Promise.reject(
                                            new Error('Debe ser positivo'),
                                          );
                                        }
                                        if (
                                          currencyType &&
                                          currencyType !== 'COP'
                                        ) {
                                          if (
                                            value.toString().includes('.') &&
                                            value.toString().split('.', 2)[1]
                                              .length > 2
                                          ) {
                                            return Promise.reject(
                                              new Error(
                                                'Debe ser un valor con máximo dos decimales',
                                              ),
                                            );
                                          }
                                        } else if (
                                          value.toString().includes('.')
                                        ) {
                                          return Promise.reject(
                                            new Error(
                                              'Debe ser un valor entero',
                                            ),
                                          );
                                        }

                                        return Promise.resolve();
                                      },
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    style={{ width: '100%' }}
                                    formatter={(value) =>
                                      `$ ${value}`.replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ',',
                                      )
                                    }
                                    parser={(value) =>
                                      value.replace(/\$\s?|(,*)/g, '')
                                    }
                                  />
                                </Form.Item>
                                <Form.Item
                                  noStyle
                                  dependencies={[
                                    'tiene_tope',
                                    'maximo_unitario',
                                    'valor_unitario',
                                  ]}
                                >
                                  {({ getFieldValue }) =>
                                    getFieldValue('tiene_tope') ? (
                                      <Row
                                        align="middle"
                                        style={{ marginBottom: '10px' }}
                                      >
                                        <Col flex="18rem">
                                          {`Valor máximo a pagar por este ${labelType}`}
                                          :{' '}
                                        </Col>
                                        <Col flex="auto">
                                          <InputNumber
                                            style={{ width: '100%' }}
                                            formatter={(value) =>
                                              `$ ${value}`.replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ',',
                                              )
                                            }
                                            value={(
                                              (getFieldValue(
                                                'valor_unitario',
                                              ) || 0) *
                                              (getFieldValue(
                                                'maximo_unitario',
                                              ) || 0)
                                            ).toFixed(2)}
                                            disabled
                                          />
                                        </Col>
                                      </Row>
                                    ) : null
                                  }
                                </Form.Item>
                              </>
                            );
                          return (
                            <>
                              {!ea && (
                                <Form.Item
                                  name="es_periodica"
                                  label={`¿La entrega de este ${labelType} es periódica?`}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Este campo es obligatorio!',
                                    },
                                  ]}
                                  tooltip={{
                                    placement: 'top',
                                    title:
                                      'Ejemplo: Entrega mensual por parte del contratista',
                                  }}
                                >
                                  <Radio.Group style={{ marginLeft: '2rem' }}>
                                    <Radio value={true}>Si</Radio>
                                    <Radio value={false}>No</Radio>
                                  </Radio.Group>
                                </Form.Item>
                              )}
                              <Form.Item
                                name="valor_total"
                                label={`Digite el valor del ${labelType} para el pago fijo`}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Este campo es obligatorio!',
                                  },
                                  {
                                    validator: (_, value) => {
                                      if (!value) {
                                        return Promise.resolve();
                                      } else if (isNaN(value)) {
                                        return Promise.reject(
                                          new Error(
                                            'Debe ser un valor numérico',
                                          ),
                                        );
                                      }
                                      if (value < 0) {
                                        return Promise.reject(
                                          new Error('Debe ser positivo'),
                                        );
                                      }

                                      if (
                                        currencyType &&
                                        currencyType !== 'COP'
                                      ) {
                                        if (
                                          value.toString().includes('.') &&
                                          value.toString().split('.', 2)[1]
                                            .length > 2
                                        ) {
                                          return Promise.reject(
                                            new Error(
                                              'Debe ser un valor con máximo dos decimales',
                                            ),
                                          );
                                        }
                                      } else if (
                                        value.toString().includes('.')
                                      ) {
                                        return Promise.reject(
                                          new Error('Debe ser un valor entero'),
                                        );
                                      }

                                      return Promise.resolve();
                                    },
                                  },
                                ]}
                              >
                                <InputNumber
                                  style={{ width: '100%' }}
                                  formatter={(value) =>
                                    `$ ${value}`.replace(
                                      /\B(?=(\d{3})+(?!\d))/g,
                                      ',',
                                    )
                                  }
                                  parser={(value) =>
                                    value.replace(/\$\s?|(,*)/g, '')
                                  }
                                />
                              </Form.Item>
                            </>
                          );
                        }}
                      </Form.Item>
                    </>
                  ) : null
                }
              </Form.Item>
            </>
          );
        }}
      </Form.Item>
    </>
  );
};

const ProductTextOnlyFields = ({ variable = false }) => {
  return (
    <>
      <Alert
        type="info"
        message="Este producto/gasto ya esta asociado a pagos. Los campos editables se
        muestran a continuación."
      />
      <br />
      <Form.Item
        name="es_apoyo"
        rules={[
          {
            required: true,
            message: 'Tiene que escoger una opción',
          },
        ]}
      >
        <Radio.Group style={{ marginLeft: '2rem' }}>
          <Radio value={false}>Producto y/o entregable</Radio>
          <Radio value={true}>Gastos u otros ítems</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item noStyle dependencies={['es_apoyo']}>
        {({ getFieldValue }) => {
          const ea = getFieldValue('es_apoyo');
          if (ea == undefined) return null;
          const labelType = ea ? 'gasto/ítem' : 'producto';
          return (
            <>
              {ea ? (
                <>
                  <Paragraph>
                    Verifique que los gastos u otros ítems variables sean
                    consistentes con los ítems del presupuesto del proyecto y/o
                    entidad
                  </Paragraph>
                  <Form.Item
                    label="Seleccione el gasto"
                    name="tipo_apoyo"
                    rules={[
                      {
                        required: true,
                        message: 'Este campo es obligatorio!',
                      },
                    ]}
                    valuePropName="initialValue"
                  >
                    <CustomSelector endpointFetch={getSupportTypes} />
                  </Form.Item>
                  <Form.Item noStyle dependencies={['tipo_apoyo']}>
                    {({ getFieldValue }) =>
                      getFieldValue('tipo_apoyo') === 100 ? (
                        <Form.Item
                          label={`Digite el concepto del ${labelType}`}
                          name="descripcion"
                          rules={[
                            {
                              required: true,
                              message: 'Este campo es obligatorio!',
                            },
                          ]}
                          tooltip={{
                            placement: 'top',
                            title: `No use las palabras "Apoyo" o "Auxilio" en el concepto del ${labelType}.`,
                          }}
                        >
                          <TextArea rows={4} bordered allowClear />
                        </Form.Item>
                      ) : null
                    }
                  </Form.Item>
                </>
              ) : (
                <Form.Item
                  name="descripcion"
                  label="Producto y/o entregable"
                  rules={[
                    {
                      required: true,
                      message: 'Este campo es obligatorio!',
                    },
                  ]}
                >
                  <TextArea rows={4} bordered allowClear />
                </Form.Item>
              )}
              <Form.Item
                name="requiere_evidencias"
                label="¿El contratista debe cargar soportes/evidencias en SIGA para la aprobación de este producto/gasto?"
                rules={[
                  {
                    required: true,
                    message: 'Tiene que escoger una opción',
                  },
                ]}
              >
                <Radio.Group style={{ marginLeft: '2rem' }}>
                  <Radio value={true}>Si</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
              {variable ? (
                <Form.Item
                  name="nombre_unitario"
                  label={`Nombre de la unidad de este ${labelType}`}
                  tooltip={{
                    placement: 'top',
                    title:
                      'Digite en singular si es hora, taller, tutoría, etc.',
                  }}
                  rules={[
                    {
                      required: true,
                      message: 'Este campo es obligatorio!',
                    },
                    {
                      type: 'string',
                      max: 50,
                      message:
                        'El nombre de la unidad no debe de superar los 50 caracteres',
                    },
                    {
                      type: 'string',
                      pattern: /^[a-záéíóúñü (){}[\]_%+"-]+$/,
                      message: 'Utilice unicamente minúsculas',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              ) : null}
            </>
          );
        }}
      </Form.Item>
    </>
  );
};

export default ProductFields;
export { ProductTextOnlyFields };
